(function () {
  'use strict';

  var root = document.querySelector('.anber-quiz');
  if (!root) return;

  var productsEl = root.querySelector('[data-quiz-products]');
  var products = [];
  try {
    products = JSON.parse((productsEl && productsEl.textContent) || '[]');
  } catch (e) {
    products = [];
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-screen]'));
  var stepScreens = screens
    .filter(function (s) {
      return s.dataset.quizScreen === 'step';
    })
    .sort(function (a, b) {
      return parseInt(a.dataset.step, 10) - parseInt(b.dataset.step, 10);
    });
  var TOTAL_STEPS = stepScreens.length;

  var order = ['intro']
    .concat(
      stepScreens.map(function (s) {
        return 'step:' + s.dataset.step;
      })
    )
    .concat(['freetext', 'result']);

  var progressEl = root.querySelector('[data-quiz-progress]');
  var progressFill = root.querySelector('[data-quiz-progress-fill]');
  var progressLabel = root.querySelector('[data-quiz-progress-label]');
  var freetextEl = root.querySelector('[data-quiz-freetext]');

  var state = {
    currentIndex: 0,
    answers: {
      gender: null,
      isGift: false,
      sensacion: [],
      salida: [],
      corazon: [],
      fondo: [],
      intensidad: null,
      ocasion: null,
      freetext: ''
    }
  };

  var SENSATION_MAP = {
    'fresco-limpio': { family: ['Cítrico', 'Acuático'], style: ['Fresco', 'Limpio', 'De diario'] },
    'dulce-adictivo': { family: ['Dulce/Goloso', 'Avainillado', 'Frutal'], style: ['Dulce', 'Sensual'] },
    'elegante-sofisticado': { family: [], style: ['Elegante', 'Sofisticado'] },
    'intenso-nocturno': { family: [], style: ['Potente', 'De noche', 'Masculino intenso'] },
    'floral-femenino': { family: ['Floral'], style: ['Femenino dulce', 'Elegante'] },
    'amaderado-masculino': { family: ['Amaderado', 'Cuero'], style: ['Masculino intenso', 'Sofisticado'] },
    'oriental-especiado': { family: ['Oriental', 'Especiado'], style: ['Árabe oriental', 'Potente'] },
    'acuatico-ligero': { family: ['Acuático'], style: ['Fresco', 'Limpio', 'Unisex versátil'] }
  };

  var SEASON_MAP = { 'Verano/calor': 'Primavera/Verano', 'Invierno/frío': 'Otoño/Invierno' };
  var INTENSITY_LEVELS = ['Suave', 'Media', 'Alta'];

  /* ---------- utilidades ---------- */

  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function normalizeList(arr) {
    return (arr || []).filter(Boolean).map(normalize);
  }

  function countMatches(productList, targetList) {
    var pList = normalizeList(productList);
    var count = 0;
    (targetList || []).forEach(function (t) {
      if (pList.indexOf(normalize(t)) !== -1) count++;
    });
    return count;
  }

  function escapeHtml(str) {
    return (str === null || str === undefined ? '' : String(str)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function uniqueReasons(list) {
    var seen = {};
    var out = [];
    list.forEach(function (r) {
      if (!r) return;
      var key = normalize(r);
      if (!seen[key]) {
        seen[key] = true;
        out.push(r);
      }
    });
    return out.slice(0, 4);
  }

  /* ---------- navegacion entre pantallas ---------- */

  function getScreenByToken(token) {
    if (token === 'intro' || token === 'freetext' || token === 'result') {
      return root.querySelector('[data-quiz-screen="' + token + '"]');
    }
    var step = token.split(':')[1];
    return root.querySelector('[data-quiz-screen="step"][data-step="' + step + '"]');
  }

  function showScreen(index) {
    screens.forEach(function (s) {
      s.classList.remove('is-active');
    });
    var token = order[index];
    var screen = getScreenByToken(token);
    if (screen) screen.classList.add('is-active');
    state.currentIndex = index;
    updateProgress(token);
    if (token === 'result') {
      computeResults();
    }
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function updateProgress(token) {
    if (!progressEl) return;
    if (token.indexOf('step:') !== 0) {
      progressEl.hidden = true;
      return;
    }
    progressEl.hidden = false;
    var step = parseInt(token.split(':')[1], 10);
    var pct = Math.round((step / TOTAL_STEPS) * 100);
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = 'Paso ' + step + ' de ' + TOTAL_STEPS;
  }

  function goNext() {
    if (state.currentIndex < order.length - 1) {
      showScreen(state.currentIndex + 1);
    }
  }

  function goBack() {
    if (state.currentIndex > 0) {
      showScreen(state.currentIndex - 1);
    }
  }

  /* ---------- seleccion en cada paso ---------- */

  function setAnswer(question, value) {
    switch (question) {
      case 'genero':
        if (value === 'Regalo') {
          state.answers.gender = null;
          state.answers.isGift = true;
        } else {
          state.answers.gender = value;
          state.answers.isGift = false;
        }
        break;
      case 'sensacion':
        state.answers.sensacion = value;
        break;
      case 'salida':
        state.answers.salida = value;
        break;
      case 'corazon':
        state.answers.corazon = value;
        break;
      case 'fondo':
        state.answers.fondo = value;
        break;
      case 'intensidad':
        state.answers.intensidad = value;
        break;
      case 'ocasion':
        state.answers.ocasion = value;
        break;
      default:
        break;
    }
  }

  function getAnswerValue(question) {
    switch (question) {
      case 'genero':
        return state.answers.isGift ? 'Regalo' : state.answers.gender;
      case 'sensacion':
        return state.answers.sensacion;
      case 'salida':
        return state.answers.salida;
      case 'corazon':
        return state.answers.corazon;
      case 'fondo':
        return state.answers.fondo;
      case 'intensidad':
        return state.answers.intensidad;
      case 'ocasion':
        return state.answers.ocasion;
      default:
        return null;
    }
  }

  function updateNextState(screen) {
    var nextBtn = screen.querySelector('[data-quiz-next]');
    if (!nextBtn) return;
    var min = parseInt(screen.dataset.min || '0', 10);
    var value = getAnswerValue(screen.dataset.question);
    var count = Array.isArray(value) ? value.length : value ? 1 : 0;
    nextBtn.disabled = count < min;
  }

  function syncMaxDisabled(items, max) {
    var selectedCount = items.filter(function (i) {
      return i.classList.contains('is-selected');
    }).length;
    items.forEach(function (i) {
      if (!i.classList.contains('is-selected')) {
        i.classList.toggle('is-disabled', selectedCount >= max);
      }
    });
  }

  function initSelectable(screen) {
    var selectMode = screen.dataset.select;
    var max = parseInt(screen.dataset.max || '1', 10);
    var question = screen.dataset.question;
    var items = Array.prototype.slice.call(
      screen.querySelectorAll('.anber-quiz__card, .anber-quiz__chip, .anber-quiz__scale-option')
    );

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var value = item.dataset.value;

        if (selectMode === 'single') {
          items.forEach(function (i) {
            i.classList.remove('is-selected');
          });
          item.classList.add('is-selected');
          setAnswer(question, value);
          updateNextState(screen);

          var delay = reducedMotion ? 0 : 350;
          window.setTimeout(function () {
            goNext();
          }, delay);
        } else {
          if (item.classList.contains('is-selected')) {
            item.classList.remove('is-selected');
          } else {
            var selectedNow = items.filter(function (i) {
              return i.classList.contains('is-selected');
            });
            if (selectedNow.length >= max) return;
            item.classList.add('is-selected');
          }

          var values = items
            .filter(function (i) {
              return i.classList.contains('is-selected');
            })
            .map(function (i) {
              return i.dataset.value;
            });
          setAnswer(question, values);
          syncMaxDisabled(items, max);
          updateNextState(screen);

          /* Auto-avance al completar el maximo del paso. Con menos
             opciones el cliente sigue con "Siguiente" (los pasos de
             notas son opcionales). Antes de avanzar se re-comprueba
             que siga seleccionado el maximo y la pantalla activa,
             por si deselecciona durante la espera. */
          if (item.classList.contains('is-selected') && values.length >= max) {
            var delayMulti = reducedMotion ? 0 : 450;
            window.setTimeout(function () {
              var stillMax =
                items.filter(function (i) {
                  return i.classList.contains('is-selected');
                }).length >= max;
              if (stillMax && screen.classList.contains('is-active')) {
                goNext();
              }
            }, delayMulti);
          }
        }
      });
    });
  }

  stepScreens.forEach(initSelectable);

  /* ---------- botones de navegacion ---------- */

  Array.prototype.slice.call(root.querySelectorAll('[data-quiz-back]')).forEach(function (btn) {
    btn.addEventListener('click', goBack);
  });

  Array.prototype.slice.call(root.querySelectorAll('[data-quiz-next]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!btn.disabled) goNext();
    });
  });

  var startBtn = root.querySelector('[data-quiz-start]');
  if (startBtn) startBtn.addEventListener('click', goNext);

  var skipBtn = root.querySelector('[data-quiz-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      state.answers.freetext = '';
      goNext();
    });
  }

  var finishBtn = root.querySelector('[data-quiz-finish]');
  if (finishBtn) {
    finishBtn.addEventListener('click', function () {
      state.answers.freetext = freetextEl ? freetextEl.value : '';
      goNext();
    });
  }

  var restartBtn = root.querySelector('[data-quiz-restart]');
  if (restartBtn) restartBtn.addEventListener('click', resetQuiz);

  function resetQuiz() {
    state.answers = {
      gender: null,
      isGift: false,
      sensacion: [],
      salida: [],
      corazon: [],
      fondo: [],
      intensidad: null,
      ocasion: null,
      freetext: ''
    };
    screens.forEach(function (s) {
      Array.prototype.slice.call(s.querySelectorAll('.is-selected')).forEach(function (i) {
        i.classList.remove('is-selected');
      });
      Array.prototype.slice.call(s.querySelectorAll('.is-disabled')).forEach(function (i) {
        i.classList.remove('is-disabled');
      });
      var nextBtn = s.querySelector('[data-quiz-next]');
      if (nextBtn) {
        var min = parseInt(s.dataset.min || '0', 10);
        nextBtn.disabled = min > 0;
      }
    });
    if (freetextEl) freetextEl.value = '';
    showScreen(0);
  }

  /* ---------- motor de scoring ---------- */

  function freetextBonus(p, text) {
    var norm = normalize(text);
    if (!norm) return 0;
    var pool = []
      .concat(p.top_notes || [], p.heart_notes || [], p.base_notes || [])
      .concat(p.fragrance_family || [], p.fragrance_style || [])
      .concat(p.occasion || []);
    if (p.intensity) pool.push(p.intensity);

    var matched = 0;
    var seen = {};
    pool.forEach(function (item) {
      var itemNorm = normalize(item);
      if (!itemNorm || seen[itemNorm]) return;
      if (norm.indexOf(itemNorm) !== -1) {
        seen[itemNorm] = true;
        matched++;
      }
    });
    return Math.min(matched * 2, 10);
  }

  function scoreProduct(p) {
    var score = 0;
    var reasons = [];

    ['salida', 'corazon', 'fondo'].forEach(function (step) {
      var selected = state.answers[step];
      if (!selected || !selected.length) return;
      var productField = step === 'salida' ? p.top_notes : step === 'corazon' ? p.heart_notes : p.base_notes;
      var pNorm = normalizeList(productField);
      selected.forEach(function (note) {
        if (pNorm.indexOf(normalize(note)) !== -1) {
          score += 5;
          reasons.push(note);
        }
      });
    });

    if (state.answers.sensacion && state.answers.sensacion.length) {
      state.answers.sensacion.forEach(function (key) {
        var map = SENSATION_MAP[key];
        if (!map) return;
        var famMatches = countMatches(p.fragrance_family, map.family);
        var styleMatches = countMatches(p.fragrance_style, map.style);
        if (famMatches > 0 && p.fragrance_family && p.fragrance_family[0]) {
          score += 4 * famMatches;
          reasons.push(p.fragrance_family[0]);
        }
        if (styleMatches > 0 && p.fragrance_style && p.fragrance_style[0]) {
          score += 4 * styleMatches;
          reasons.push(p.fragrance_style[0]);
        }
      });
    }

    if (state.answers.gender) {
      var pGender = normalize(p.gender);
      if (pGender === normalize(state.answers.gender) || pGender === 'unisex') {
        score += 3;
      }
    }

    if (state.answers.intensidad) {
      var pIdx = INTENSITY_LEVELS.indexOf(p.intensity);
      var aIdx = INTENSITY_LEVELS.indexOf(state.answers.intensidad);
      if (pIdx !== -1 && aIdx !== -1) {
        if (pIdx === aIdx) score += 2;
        else if (Math.abs(pIdx - aIdx) === 1) score += 1;
      }
    }

    if (state.answers.ocasion) {
      var pOcc = normalizeList(p.occasion);
      if (pOcc.indexOf(normalize(state.answers.ocasion)) !== -1) {
        score += 2;
        reasons.push(state.answers.ocasion);
      }
      var seasonTarget = SEASON_MAP[state.answers.ocasion];
      var pSeason = normalizeList(p.season);
      if (seasonTarget && pSeason.indexOf(normalize(seasonTarget)) !== -1) score += 1;
      if (pSeason.indexOf(normalize('Todo el año')) !== -1) score += 1;
    }

    if (p.featured) score += 1;

    if (state.answers.freetext) {
      score += freetextBonus(p, state.answers.freetext);
    }

    return { score: score, reasons: uniqueReasons(reasons) };
  }

  function computeResults() {
    var isGift = state.answers.isGift;
    var pool = products.filter(function (p) {
      if (!p.quiz_enabled || !p.available) return false;
      if (!isGift && p.product_recommendation_type !== 'Perfume individual') return false;
      return true;
    });

    if (!pool.length) {
      pool = products.filter(function (p) {
        return p.quiz_enabled && p.available;
      });
    }

    var scored = pool.map(function (p) {
      var r = scoreProduct(p);
      return { product: p, score: r.score, reasons: r.reasons };
    });
    scored.sort(function (a, b) {
      return b.score - a.score;
    });

    if (!scored.length) {
      scored = products
        .filter(function (p) {
          return p.available;
        })
        .map(function (p) {
          return { product: p, score: p.featured ? 1 : 0, reasons: [] };
        });
      scored.sort(function (a, b) {
        return b.score - a.score;
      });
    }

    renderResults(scored.slice(0, 4));
  }

  /* ---------- render de resultados ---------- */

  function notesText(p) {
    var parts = [];
    if (p.top_notes && p.top_notes.length) parts.push('<strong>Salida:</strong> ' + escapeHtml(p.top_notes.join(', ')));
    if (p.heart_notes && p.heart_notes.length)
      parts.push('<strong>Corazón:</strong> ' + escapeHtml(p.heart_notes.join(', ')));
    if (p.base_notes && p.base_notes.length) parts.push('<strong>Fondo:</strong> ' + escapeHtml(p.base_notes.join(', ')));
    return parts.join(' &middot; ');
  }

  function buildMatchCard(item) {
    var p = item.product;
    var wrap = document.createElement('div');
    wrap.className = 'anber-quiz__match';
    wrap.innerHTML =
      '<span class="anber-quiz__match-badge">Tu mejor match</span>' +
      '<div class="anber-quiz__match-media">' +
      (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="anber-quiz__match-content">' +
      '<h3 class="anber-quiz__match-title">' +
      escapeHtml(p.title) +
      '</h3>' +
      '<p class="anber-quiz__match-price">' +
      escapeHtml(p.price) +
      '</p>' +
      (item.reasons.length
        ? '<ul class="anber-quiz__match-reasons">' +
          item.reasons
            .map(function (r) {
              return '<li>' + escapeHtml(r) + '</li>';
            })
            .join('') +
          '</ul>'
        : '') +
      (notesText(p) ? '<p class="anber-quiz__match-notes">' + notesText(p) + '</p>' : '') +
      '<div class="anber-quiz__match-actions">' +
      '<a class="anber-btn anber-btn--outline" href="/products/' +
      escapeHtml(p.handle) +
      '">Ver producto</a>' +
      (p.variant_id
        ? '<button type="button" class="anber-btn anber-btn--gold" data-quiz-add-to-cart data-variant-id="' +
          escapeHtml(p.variant_id) +
          '">Añadir</button>'
        : '') +
      '</div>' +
      '</div>';
    return wrap;
  }

  function buildAltCard(item) {
    var p = item.product;
    var card = document.createElement('div');
    card.className = 'anber-quiz__alt-card';
    card.innerHTML =
      '<div class="anber-quiz__alt-card__media">' +
      (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<h4 class="anber-quiz__alt-card__title">' +
      escapeHtml(p.title) +
      '</h4>' +
      '<p class="anber-quiz__alt-card__price">' +
      escapeHtml(p.price) +
      '</p>' +
      (item.reasons.length
        ? '<p class="anber-quiz__alt-card__reasons">Coincide por: ' + escapeHtml(item.reasons.join(', ')) + '</p>'
        : '') +
      '<div class="anber-quiz__alt-card__actions">' +
      '<a class="anber-btn anber-btn--outline" href="/products/' +
      escapeHtml(p.handle) +
      '">Ver</a>' +
      (p.variant_id
        ? '<button type="button" class="anber-btn anber-btn--gold" data-quiz-add-to-cart data-variant-id="' +
          escapeHtml(p.variant_id) +
          '">Añadir</button>'
        : '') +
      '</div>';
    return card;
  }

  function renderResults(list) {
    var mainEl = root.querySelector('[data-quiz-result-main]');
    var altsEl = root.querySelector('[data-quiz-result-alts]');
    if (!mainEl || !altsEl) return;
    mainEl.innerHTML = '';
    altsEl.innerHTML = '';

    if (!list.length) {
      mainEl.innerHTML =
        '<p class="anber-quiz__loading">No hemos podido encontrar resultados ahora mismo. Explora nuestro catálogo completo.</p>';
      return;
    }

    mainEl.appendChild(buildMatchCard(list[0]));
    list.slice(1, 4).forEach(function (item) {
      altsEl.appendChild(buildAltCard(item));
    });
  }

  /* ---------- anadir al carrito ---------- */

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-quiz-add-to-cart]') : null;
    if (!btn) return;
    addToCart(btn);
  });

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || !window.routes || !window.routes.cart_add_url) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Añadido ✓';
        refreshCartBubble();
        window.setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Inténtalo de nuevo';
        window.setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      });
  }

  function refreshCartBubble() {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(window.routes.cart_url + '?sections=cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && data && data['cart-icon-bubble']) {
          el.innerHTML = data['cart-icon-bubble'];
        }
      })
      .catch(function () {});
  }

  /* ---------- arranque ---------- */

  showScreen(0);
})();
